import type { ClassLevel, SoilClassification } from '../types/parameters.types';

export const getClassLevel = (classification: SoilClassification): ClassLevel => {
	if (classification === 'Muito_Baixo' || classification === 'Baixo') return 'low';
	if (classification === 'Medio') return 'medium';
	return 'high';
};
